export type BrochurePage = {
  id: number
  label: string
  description: string
  image: string
}

/**
 * The Viral Shantivan brochure, page by page, in printing order.
 * These pages are combined into a single PDF on download.
 */
export const brochurePages: BrochurePage[] = [
  {
    id: 1,
    label: 'Cover & Location',
    description:
      'Swastik Infra Developer — Viral Shantivan cover, location map and contact details',
    image:
      'https://cdn.magicpatterns.com/uploads/cM6GJ4Cr2GYeypHVuGXddf/Screenshot_2026-08-05_232609.png',
  },
  {
    id: 2,
    label: 'Where Luxury Meets Legacy',
    description:
      'Project introduction and elevation — a 7-storey masterpiece 2 minutes from Virar Platform No. 1',
    image:
      'https://cdn.magicpatterns.com/uploads/abZE2BaHeS7uQ1hWGNR53a/Screenshot_2026-08-05_232618.png',
  },
  {
    id: 3,
    label: 'Project Highlights',
    description:
      'Rooftop garden layout, lifestyle amenities and key project highlights',
    image:
      'https://cdn.magicpatterns.com/uploads/fGNEUrrZYuSqcYWBWEfD4d/Screenshot_2026-08-05_232655.png',
  },
  {
    id: 4,
    label: 'Unit Layouts & Amenities',
    description:
      '3D layouts for 1 BHK and 2 BHK homes with the full amenities list',
    image:
      'https://cdn.magicpatterns.com/uploads/1Atfz2UR6vgJ7M8AcjPFWz/Screenshot_2026-08-05_232647.png',
  },
  {
    id: 5,
    label: 'Specifications',
    description:
      'Kitchen, bathroom, doors, electrification and paint specifications',
    image:
      'https://cdn.magicpatterns.com/uploads/nz3EQXF1fnCKt5wyg3cXx7/Screenshot_2026-08-05_232630.png',
  },
]
